export default "__VITE_ASSET__DrmVvUxP__"